import { Reveal } from "@/components/Reveal";
import { EditableText } from "@/context/ContentContext";

export default function ChiSono() {
  return (
    <div data-testid="chisono-page" className="pt-32 md:pt-44 pb-24 md:pb-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <EditableText k="chisono_eyebrow" as="p" className="font-mono2 uppercase tracking-widest text-darkgrey mb-6" />
          <h1 className="font-heading leading-[0.95] max-w-4xl">
            <EditableText k="chisono_title1" as="span" className="block" />
            <EditableText k="chisono_title2" as="span" className="block" />
          </h1>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mt-20">
          <div className="md:col-span-4">
            <div className="md:sticky md:top-32 space-y-8">
              <Reveal>
                <p className="font-mono2 text-xs uppercase tracking-widest text-darkgrey mb-3">Punti di vista</p>
                <EditableText k="chisono_punti_body" as="p" className="font-mono2 text-darkgrey leading-relaxed" />
              </Reveal>
              <Reveal delay={0.1}>
                <figure className="relative" data-testid="chisono-portrait-quote">
                  <span aria-hidden="true" className="block font-heading font-bold text-ink text-6xl md:text-7xl leading-none mb-[-0.25em] select-none">“</span>
                  <img src="https://customer-assets-cm19k8pv.emergentagent.net/job_strategy-shop/artifacts/yten6tzx_b925f01a-9de5-40aa-a2f2-4c7f348727ef_0_%24%7BimageGen_1_output_1%7D.webp"
                    alt="Valentina Garavaglia" className="w-full border border-darkgrey/40" />
                  <span aria-hidden="true" className="block text-right font-heading font-bold text-ink text-6xl md:text-7xl leading-none mt-[-0.15em] select-none">”</span>
                </figure>
              </Reveal>
            </div>
          </div>

          <div className="md:col-span-7 md:col-start-6 space-y-12">
            <Reveal>
              <EditableText k="chisono_lead" as="p" className="font-editorial leading-relaxed text-ink" />
            </Reveal>
            <Reveal delay={0.1}>
              <EditableText k="chisono_body1" as="p" className="font-body text-darkgrey leading-relaxed" />
            </Reveal>
            <Reveal delay={0.15}>
              <EditableText k="chisono_heading" as="p" className="font-heading leading-tight" />
            </Reveal>
            <Reveal delay={0.2}>
              <EditableText k="chisono_body2" as="p" className="font-body text-darkgrey leading-relaxed" />
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  );
}
